import { Card, Typography, Divider, Space, Tag } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { MyBtn } from "Components/MyBtn/MyBtn";
import { useNavigate } from "react-router";
const { Title, Paragraph, Text } = Typography;

export default function Article() {
  const navigate = useNavigate();
  return (
    <div style={{ margin: "0 auto" }}>
      <Card style={{ borderRadius: 16 }}>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <div>
            <Title level={2}>Як це працює?</Title>
            <Space>
              <Tag color="blue">Документація</Tag>
              <Tag color="orange">Version: 1.0.5</Tag>
              <MyBtn
                icon={<QuestionCircleOutlined />}
                text={"Що нового?"}
                type=""
                onClick={() => navigate("/whats-new")}
              />
              <Text type="secondary">Оновлено: 15.06.2026</Text>
            </Space>
          </div>

          <Divider />

          <Typography>
            <Paragraph>
              Дана платформа створена для електронного бланкування виконаних
              робіт. Суть полягає у концентрації збору інформації по фактичному
              виконанню обсягів робіт, та вести облік прогресу в одному місці.
            </Paragraph>

            <Paragraph>
              Інженер створює проєкт і визначає структуру доступів: учасників,
              керівників робіт, виконавців та осіб, відповідальних за перевірку
              та фінансовий контроль (наприклад, кошторисники або бухгалтерія).
            </Paragraph>

            <Title level={4}>Ролі та доступи</Title>

            <Paragraph>Система підтримує гнучку модель ролей:</Paragraph>

            <ul>
              <li>Інженер — створює проєкт та налаштовує доступи</li>
              <li>Виконавці — заповнюють та подають бланки</li>
              <li>Контролюючі особи — перевіряють дані</li>
            </ul>

            <Title level={4}>Формати представлення даних</Title>

            <Paragraph>
              Електронні бланки можуть переглядатися у двох режимах:
            </Paragraph>

            <ul>
              <li>
                <b>Календарний вигляд</b> — загальна картина виконання робіт та
                подій по проєкту
              </li>
              <li>
                <b>Розширена таблиця</b> — детальний розподіл по роботах із
                відсотком виконання та статусами
              </li>
            </ul>

            <Title level={4}>Процес роботи</Title>

            <Paragraph>
              Керівники або уповноважені користувачі можуть формувати бланки
              вручну або надсилати дані через Telegram чи безпосередньо через
              платформу. Після перевірки інформація може бути передана до
              фінансового обліку, включно з нарахуванням заробітної плати та
              формуванням звітності.
            </Paragraph>

            <Paragraph>
              Такий підхід дозволяє об’єднати польову роботу, контроль та
              фінансову аналітику в одній системі.
            </Paragraph>
          </Typography>
        </Space>
      </Card>
    </div>
  );
}
